import React, { useEffect, useMemo, useState } from "react";
import {
    Alert, Chip, CircularProgress, IconButton, ListItemIcon, ListItemText, Menu,
    MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import AddAdminUser from "../../components/administracionUsuarios/modalesAdminUser/addAdminUser";
import UpdateAdminUser from "../../components/administracionUsuarios/modalesAdminUser/updateAdminUser";
import DeleteAdminUser from "../../components/administracionUsuarios/modalesAdminUser/deleteAdminUser";

import { useGetAdminUser } from "../../hooks/AdministracionUsuarios/adminUsuarios/getAdminUser";
import { useGetCatalogoPerfiles } from "../../hooks/catalogosPerfiles/getCatalogoPerfiles";
import { TablePagination } from "@mui/material";
export default function UsuariosView() {

    // agregar usuario 
    const [openAddUser, setOpenAddUser] = useState(false);

    const handleOpenAddUser = () => { setOpenAddUser(true); };

    const handleCloseAddUser = () => { setOpenAddUser(false); };

    const handleUserCreated = async () => { await obtenerUsuarios(); };


    // editar usuario
    const [openUpdateUser, setOpenUpdateUser] = useState(false);

    const handleCloseUpdateUser = () => { setOpenUpdateUser(false); };

    const handleUserUpdated = async () => {
        await obtenerUsuarios();
        setOpenUpdateUser(false);
    };

    // eliminar usuario
    const [openDeleteUser, setOpenDeleteUser] = useState(false);

    const handleCloseDeleteUser = () => {
        setOpenDeleteUser(false);
    };

    const handleUserDeleted = async () => {
        await obtenerUsuarios();
        setOpenDeleteUser(false);
    };


    const { usuarios, loading, error, obtenerUsuarios, } = useGetAdminUser();

    const { perfiles, loading: loadingPerfiles, error: errorPerfiles, obtenerCatalogoPerfiles, } = useGetCatalogoPerfiles();

    const [busqueda, setBusqueda] = useState("");

    // buscador filtro
    const usuariosFiltrados = useMemo(() => {
        const texto = busqueda.trim().toLowerCase();

        if (!texto) return usuarios;

        return usuarios.filter((usuario) => {
            const nombre = (usuario.nombre ?? "").toLowerCase();
            const correo = (usuario.correo ?? "").toLowerCase();

            return (nombre.includes(texto) || correo.includes(texto));
        });
    }, [usuarios, busqueda]);

    // carga de informacion 
    useEffect(() => {
        const cargarDatos = async () => {
            await Promise.all([
                obtenerUsuarios(),
                obtenerCatalogoPerfiles(),
            ]);

        };
        cargarDatos();

    }, []);

    // datos de catalogo de perfiles
    const perfilesMap = useMemo(() => {
        const mapa: Record<number, string> = {};
        perfiles.forEach((perfil) => {
            mapa[perfil.id] = perfil.nombre;
        });
        return mapa;
    }, [perfiles]);

    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedUsuario, setSelectedUsuario] = useState<any>(null);

    const handleOpenMenu = (
        event: React.MouseEvent<HTMLElement>,
        usuario: any
    ) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedUsuario(usuario);
    };

    const handleCloseMenu = () => {
        setMenuAnchorEl(null);

    };

    const handleEditar = () => {
        setOpenUpdateUser(true);
        handleCloseMenu();
    };

    const handleEliminar = () => {
        if (!selectedUsuario) {
            return;
        }
        setOpenDeleteUser(true);
        handleCloseMenu();
    };

    //paginador 
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;

    const handleChangePage = (
        event: unknown,
        newPage: number
    ) => {
        setPage(newPage);
    };
    if (loading || loadingPerfiles) {
        return <CircularProgress />;
    }

    if (error || errorPerfiles) {
        return (
            <Alert severity="error">
                {error || errorPerfiles}
            </Alert>
        );
    }
    return (

        <Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
            >

                <TextField
                    size="small"
                    placeholder="Buscar por nombre o correo..."
                    value={busqueda}
                    onChange={(e) => {
                        setBusqueda(e.target.value);
                        setPage(0);
                    }}
                    sx={{
                        width: 350,
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleOpenAddUser}
                    sx={{
                        bgcolor: "#1976d2",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2,
                        "&:hover": {
                            bgcolor: "#1565c0",
                        },
                    }}
                >
                    Agregar Usuario
                </Button>

            </Box>

            <TableContainer component={Paper}>

                <Table>

                    <TableHead>

                        <TableRow>

                            <TableCell>Nombre</TableCell>

                            <TableCell>Correo</TableCell>

                            <TableCell>Perfil</TableCell>

                            <TableCell>Estatus</TableCell>

                            <TableCell align="center">
                                Acciones
                            </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {usuariosFiltrados
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((usuario) => (

                                <TableRow key={usuario.id}>

                                    <TableCell>
                                        {usuario.nombre}
                                    </TableCell>

                                    <TableCell>
                                        {usuario.correo}
                                    </TableCell>

                                    <TableCell>
                                        {perfilesMap[usuario.idPerfil] ?? "-"}
                                    </TableCell>

                                    <TableCell>

                                        <Chip
                                            label={
                                                Number(usuario.estatus) === 1
                                                    ? "Activo"
                                                    : "Inactivo"
                                            }
                                            color={
                                                Number(usuario.estatus) === 1
                                                    ? "success"
                                                    : "error"
                                            }
                                            size="small"
                                            sx={{
                                                minWidth: 80,
                                                fontWeight: 600,
                                            }}
                                        />

                                    </TableCell>

                                    <TableCell align="center">

                                        <IconButton
                                            size="small"
                                            onClick={(event) =>
                                                handleOpenMenu(event, usuario)
                                            }
                                        >
                                            <MoreVertIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>

                            ))}

                        {usuariosFiltrados.length === 0 && (

                            <TableRow>

                                <TableCell
                                    colSpan={5}
                                    align="center"
                                >
                                    No se encontraron usuarios.
                                </TableCell>

                            </TableRow>

                        )}
                    </TableBody>

                </Table>

                <TablePagination
                    component="div"
                    count={usuariosFiltrados.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[10]}
                    labelRowsPerPage="Registros por página:"
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count}`
                    }
                />
                <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleCloseMenu}
                >

                    <MenuItem onClick={handleEditar}>

                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText>
                            Editar
                        </ListItemText>

                    </MenuItem>

                    <MenuItem
                        sx={{ color: "error.main" }}
                        onClick={handleEliminar}
                    >

                        <ListItemIcon>
                            <DeleteIcon
                                color="error"
                                fontSize="small"
                            />
                        </ListItemIcon>

                        <ListItemText
                            primary="Eliminar"
                            primaryTypographyProps={{
                                color: "error",
                            }}
                        />

                    </MenuItem>

                </Menu>

            </TableContainer>


            {/*modales */}
            <AddAdminUser
                open={openAddUser}
                onClose={handleCloseAddUser}
                onSuccess={handleUserCreated}
            />

            <UpdateAdminUser
                open={openUpdateUser}
                onClose={handleCloseUpdateUser}
                onSuccess={handleUserUpdated}
                usuario={selectedUsuario}
            />

            <DeleteAdminUser
                open={openDeleteUser}
                onClose={handleCloseDeleteUser}
                onSuccess={handleUserDeleted}
                usuario={selectedUsuario}
            />

        </Box>

    );

}